import { Form } from "components";

export default function Filters({
  filters,
  onChange,
  onClean,
}) {
  return (
    <Form>
      <div className="row">
        <Form.Field className="col-md-6">
          <Form.Label>Nome</Form.Label>
          <Form.Input
            value={filters.name}
            onChange={(event) => onChange("name", event.target.value)}
          />
        </Form.Field>

        <Form.Field className="col-md-6">
          <Form.Label>Motivo da pontuação</Form.Label>
          <Form.Input
            value={filters.reason}
            onChange={(event) => onChange("reason", event.target.value)}
          />
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Button className="button-clean-filter" onClick={onClean}>
            Resetar filtros
          </Form.Button>
        </Form.Field>
      </div>
    </Form>
  );
}
